module.exports = __webpack_public_path__ + "static/media/triangle.cc6f0010.svg";